/* ==========================================================================
   OVRS — base das sections novas
   Reveal no scroll + carrosseis. Nenhuma logica de compra vive aqui.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- reveal ---------- */

  var observer = null;

  function observe(scope) {
    var targets = (scope || document).querySelectorAll('.ovrs-reveal:not(.is-in)');
    if (!targets.length) return;

    // Sem IntersectionObserver o conteudo aparece direto — nunca some.
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-in');
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12 }
      );
    }

    for (var j = 0; j < targets.length; j++) observer.observe(targets[j]);
  }

  /* ---------- galeria elastica (coleções) ---------- */

  function wireElastic(scope) {
    var galleries = (scope || document).querySelectorAll('[data-ovrs-elastic]');

    galleries.forEach(function (gallery) {
      if (gallery.dataset.ovrsElasticReady === 'true') return;
      gallery.dataset.ovrsElasticReady = 'true';

      var items = gallery.querySelectorAll('[data-ovrs-elastic-item]');
      if (!items.length) return;

      function activate(item) {
        items.forEach(function (other) {
          other.classList.toggle('is-active', other === item);
        });
      }

      items.forEach(function (item) {
        // Desktop abre no hover; no toque so o toque abre, entao o primeiro
        // toque expande e o segundo (no link) navega.
        item.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover: hover)').matches) activate(item);
        });

        item.addEventListener(
          'click',
          function (e) {
            if (window.matchMedia('(hover: hover)').matches) return;
            if (!item.classList.contains('is-active')) {
              e.preventDefault();
              activate(item);
            }
          },
          true
        );

        item.addEventListener('focusin', function () {
          activate(item);
        });
      });

      activate(items[0]);
    });
  }

  /* ---------- marquee do Instagram: pausa no toque ---------- */

  function wireIgRails(scope) {
    var rails = (scope || document).querySelectorAll('[data-ovrs-ig-rail]');

    rails.forEach(function (rail) {
      if (rail.dataset.ovrsIgReady === 'true') return;
      rail.dataset.ovrsIgReady = 'true';

      // arrastar precisa parar a animacao, senao o dedo briga com o CSS
      rail.addEventListener('touchstart', function () { rail.classList.add('is-paused'); }, { passive: true });
      rail.addEventListener('pointerdown', function () { rail.classList.add('is-paused'); });
    });
  }

  /* ---------- boot ---------- */

  function init(scope) {
    observe(scope);
    wireElastic(scope);
    wireIgRails(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme Editor: section recarregada precisa reobservar os elementos novos
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
